// extracted by mini-css-extract-plugin
module.exports = {"shadowSection":"ShadowSection_shadowSection__G0F1t"};